module.exports = __webpack_public_path__ + "static/img/qi_3.30db9e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_3.jpg
// module id = Nxhw
// module chunks = 1